import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OverlayService } from '../../../../../services/overlay.service';
import { NewApiHttpService, NewApiResponse } from '../../../../../services/new-api-http.service';
import { UserListComponent } from '../user-list.component';

@Component({
	selector: 'app-delete-user-form',
	templateUrl: './delete-user-form.component.html',
	styleUrls: ['./delete-user-form.component.scss']
})
export class DeleteUserFormComponent implements OnInit {
	@Input() userData;
	@Output() output = new EventEmitter();
	showResponse = false;
	sending = false;
	sentOk = false;
	email;
	userName;
	isActive = true;
	password;
	company;
	role_id;
	type = 'edit';
	tenant_id;
	userId = -1;
	terminate;
	deactivate = false;

	constructor(private overlay: OverlayService, private userList: UserListComponent, private newApiHttpService: NewApiHttpService) {}

	ngOnInit() {
		if (this.userData) {
			this.userId = this.userData.id;
			this.email = this.userData.email;
			this.userName = this.userData.name;
			this.company = this.userData.company;
			this.tenant_id = this.userData.tenant_id;
			this.role_id = this.userData.role_id;
			this.isActive = typeof this.userData.active === 'undefined' ? true : this.userData.active;
			this.terminate = typeof this.userData.terminate === 'undefined' ? false : this.userData.terminate;
		}
		this.deactivate = !this.isActive;
	}

	submitDeleteUserForm(values) {
		this.sending = true;
		this.deleteUser(values);
	}

	deleteUser(user) {
		const active = this.deactivate ? 0 : 1;

		let data = {
			id: this.userId,
			name: this.userName,
			active: active,
			email: this.email,
			company: this.company,
			role: Number(this.role_id)
		};

		if (this.tenant_id) {
			data['tenant_id'] = this.tenant_id;
		}

		if (user.terminate) {
			data['terminate'] = user.terminate;
		}

		if (this.userId === -1) {
			this.sentOk = false;
			this.sending = false;
		} else {
			this.newApiHttpService['newApiRequestPut']('user', data).subscribe(
				(response: NewApiResponse) => {
					this.showResponse = true;
					if (!response || !response.status) {
						this.sentOk = false;
						this.sending = false;
					} else if (response.status) {
						this.sentOk = true;
					}
				},
				(error) => this.overlay.updateOverlay(true, error, 'alert'),
				() => {}
			);
		}
	}

	closeAfterDelete() {
		this.userList.refreshUsers();
		this.userList.showDeleteModal = false;
	}

	approveTerminate(event: MouseEvent) {
		if (!this.terminate) {
			const sure = confirm(
				`Are you sure you want to terminate all of the components in the ${this.email} account (ID: ${this.userId})?`
			);
			if (!sure) {
				event.preventDefault();
			} else {
				this.deactivate = true;
			}
		}
	}

	checkActive() {
		if (this.deactivate) {
			this.terminate = false;
		}
	}
}
